import React from 'react';

const REGIONS = [
  { label: 'Europe', countries: ['Norway','Sweden','Denmark','Finland','United Kingdom','Germany','France','Italy','Spain','Netherlands','Belgium','Austria','Switzerland','Portugal','Ireland','Greece','Poland','Czech Republic','Hungary','Romania','Bulgaria','Croatia','Serbia','Slovakia','Slovenia','Estonia','Latvia','Lithuania','Luxembourg','Malta','Cyprus','Iceland'] },
  { label: 'North America', countries: ['United States','Canada','Mexico'] },
  { label: 'Latin America', countries: ['Brazil','Argentina','Chile','Colombia','Peru','Venezuela','Ecuador','Bolivia','Uruguay','Paraguay','Guatemala','Cuba','Costa Rica','Panama','Honduras','El Salvador','Nicaragua','Dominican Republic','Jamaica','Trinidad and Tobago'] },
  { label: 'Asia-Pacific', countries: ['Japan','China','South Korea','India','Australia','New Zealand','Singapore','Thailand','Indonesia','Malaysia','Philippines','Vietnam','Hong Kong','Taiwan','Bangladesh','Pakistan','Sri Lanka','Nepal','Myanmar','Cambodia'] },
  { label: 'Middle East', countries: ['United Arab Emirates','Qatar','Saudi Arabia','Kuwait','Bahrain','Oman','Jordan','Israel','Turkey','Iran','Iraq','Lebanon'] },
  { label: 'Africa', countries: ['South Africa','Egypt','Morocco','Kenya','Nigeria','Ethiopia','Ghana','Tunisia','Tanzania','Uganda','Senegal','Cameroon','Mozambique','Zambia','Zimbabwe'] },
  { label: 'Oceania', countries: ['Australia','New Zealand','Fiji','Papua New Guinea','Vanuatu','Samoa','Tonga'] },
];

const STATUSES = [
  { value: 'proposed',  label: '🟡 Proposed' },
  { value: 'trending',  label: '🔥 Trending' },
  { value: 'announced', label: '📢 Announced' },
  { value: 'launched',  label: '✅ Launched' },
  { value: 'rejected',  label: '❌ Rejected' },
];

const DISTANCES = [
  { value: 'short',  label: 'Short-Haul (<500km)',      test: (km) => km < 500 },
  { value: 'medium', label: 'Medium-Haul (500–2000km)', test: (km) => km >= 500 && km < 2000 },
  { value: 'long',   label: 'Long-Haul (2000–6000km)',  test: (km) => km >= 2000 && km < 6000 },
  { value: 'ultra',  label: 'Ultra Long-Haul (>6000km)', test: (km) => km >= 6000 },
];

export function applyFilters(routes, { region, status, distance }) {
  return routes.filter((route) => {
    if (status && route.status !== status) return false;

    if (distance) {
      const km = route.analysis?.distance_km || route.distance_km || 0;
      const distDef = DISTANCES.find((d) => d.value === distance);
      if (distDef && !distDef.test(km)) return false;
    }

    if (region) {
      const regionDef = REGIONS.find((r) => r.label === region);
      if (regionDef) {
        const originCountry = route.origin_airport?.country || '';
        const destCountry = route.destination_airport?.country || '';
        if (!regionDef.countries.includes(originCountry) && !regionDef.countries.includes(destCountry)) {
          return false;
        }
      }
    }

    return true;
  });
}

function FilterBar({ filters, onChange }) {
  const { region, status, distance } = filters;

  const setFilter = (key, value) => {
    onChange({ ...filters, [key]: filters[key] === value ? '' : value });
  };

  const hasActiveFilter = region || status || distance;

  return (
    <div className="filter-bar">
      {hasActiveFilter && (
        <div className="active-filters">
          {region && (
            <span className="filter-chip" onClick={() => setFilter('region', region)}>
              {region} ✕
            </span>
          )}
          {status && (
            <span className="filter-chip" onClick={() => setFilter('status', status)}>
              {STATUSES.find((s) => s.value === status)?.label} ✕
            </span>
          )}
          {distance && (
            <span className="filter-chip" onClick={() => setFilter('distance', distance)}>
              {DISTANCES.find((d) => d.value === distance)?.label} ✕
            </span>
          )}
          <button className="btn btn-secondary clear-all" onClick={() => onChange({ region: '', status: '', distance: '' })}>
            Clear all
          </button>
        </div>
      )}

      <details className="filter-section-group">
        <summary>Region</summary>
        <div className="filter-options">
          {REGIONS.map((r) => (
            <button
              key={r.label}
              className={`filter-option ${region === r.label ? 'active' : ''}`}
              onClick={() => setFilter('region', r.label)}
            >
              {r.label}
            </button>
          ))}
        </div>
      </details>

      <details className="filter-section-group">
        <summary>Status</summary>
        <div className="filter-options">
          {STATUSES.map((s) => (
            <button
              key={s.value}
              className={`filter-option ${status === s.value ? 'active' : ''}`}
              onClick={() => setFilter('status', s.value)}
            >
              {s.label}
            </button>
          ))}
        </div>
      </details>

      <details className="filter-section-group">
        <summary>Distance</summary>
        <div className="filter-options">
          {DISTANCES.map((d) => (
            <button
              key={d.value}
              className={`filter-option ${distance === d.value ? 'active' : ''}`}
              onClick={() => setFilter('distance', d.value)}
            >
              {d.label}
            </button>
          ))}
        </div>
      </details>
    </div>
  );
}

export default FilterBar;
